module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.CPACommDetailLan.datailText) + "  (" + _vm._s(_vm.queryObj.REPORT_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "type": "warning",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.CPACommDetailLan.goback))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.CPACommDetailLan,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran,
      "name": _vm.name
    }
  }, [_c('div', {
    staticClass: "cpa-detail",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "cpa-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.CPACommDetailLan.proxyAccount) + " " + _vm._s(_vm.queryObj.IB_ID))])]), _vm._v(" "), _c('div', {
    staticClass: "cpa-detail"
  }, [_c('span', [_vm._v(_vm._s(_vm.CPACommDetailLan.commissionType) + " " + _vm._s(_vm.CPACommDetailLan.type))])])])]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d781ca40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBResult/CPAMonthlyCommDetailResult.vue
// module id = 1140
// module chunks = 1